export const PXAnchorLinks = (function() {
	'use strict';

	let $link, $win, offset;

	function init() {

		$link = $('.pxblock--anchor-links li a');
		$win = $(window);
		offset = 100;

		if ($link) {
			events();
		}
	}

	function events() {
		checkForActiveBlock();
		$win.scroll(checkForActiveBlock);
	}

	function checkForActiveBlock(){
		$link.each(function(){
			let blockID = $(this).attr('href').replace('#', '');
			let block = document.getElementById(blockID);

			if (block) {
				let inView = isInViewport(block);

				if (inView) {
					activateLink($(this));
					return false;
				}
			}
		});
	}

	function activateLink($t){
		$t.addClass('active');
		$link.not($t).removeClass('active');
	}

	function isInViewport(element) {
    const rect = element.getBoundingClientRect();

    return (
      rect.bottom >= offset
    );
	}

	return {
		init: init
	};
})();
